import React, { type ReactNode, memo } from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import type { MenuNode } from '../../types.tsx';

const listStyles = xcss({
	listStyle: 'none',
	padding: 'space.0',
	margin: 'space.0',
});

const listItemStyles = xcss({
	padding: 'space.0',
	margin: 'space.0',
});

export const ContextMenuNodeList = memo(
	({
		menuNodes,
		renderNode,
	}: {
		menuNodes: MenuNode[] | MenuNode;
		renderNode: (node: MenuNode) => ReactNode;
	}) => {
		if (Array.isArray(menuNodes))
			return (
				<Box as="ul" xcss={listStyles}>
					{menuNodes.map((menuNode) => (
						<Box as="li" key={menuNode.id} xcss={listItemStyles}>
							{renderNode(menuNode)}
						</Box>
					))}
				</Box>
			);
		if (!Array.isArray(menuNodes)) return renderNode(menuNodes);
	},
);
